// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `forge-icon {
  font-size: 1.3rem;
  margin-left: 1rem;
}

.badge-with-close {
  display: flex;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/app/meeting-manager/badge-with-close/badge-with-close.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,iBAAA;AACJ;;AACA;EACI,aAAA;EACA,mBAAA;AAEJ","sourcesContent":["forge-icon{\r\n    font-size: 1.3rem;\r\n    margin-left: 1rem;\r\n}\r\n.badge-with-close{\r\n    display:flex;\r\n    flex-direction: row;\r\n   \r\n    \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
